import { NitrogenSimulationType } from "@/types/enums";

export function getSimulationTypeLabel(simulationType: NitrogenSimulationType) {
    return {
        [NitrogenSimulationType.Sentinel]: "Sentinel",
        [NitrogenSimulationType.Decadal50]: "Decadal 50",
        [NitrogenSimulationType.Decadal90]: "Decadal 90",
        [NitrogenSimulationType.Drought]: "Drought",
        [NitrogenSimulationType.Wet]: "Wet",
        [NitrogenSimulationType.No_Rate]: "No Application",
        [NitrogenSimulationType.Max_Rate]: "Unlimited Nitrogen",
    }[simulationType];
}

export function getSimulationTypeSortValue(
    simulationType: NitrogenSimulationType,
) {
    return {
        [NitrogenSimulationType.Sentinel]: 0,
        [NitrogenSimulationType.Decadal50]: 1,
        [NitrogenSimulationType.Decadal90]: 2,
        [NitrogenSimulationType.Drought]: 3,
        [NitrogenSimulationType.Wet]: 4,
        [NitrogenSimulationType.No_Rate]: 5,
        [NitrogenSimulationType.Max_Rate]: 6,
    }[simulationType];
}
